import { Injectable, signal } from '@angular/core';
import { SeekopTokenClaims, decodeJwtPayload } from '@core/utils/jwt-decoder';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly _user = signal<SeekopTokenClaims | null>(null);
  readonly user = this._user.asReadonly();

  setFromToken(accessToken: string): void {
    this._user.set(decodeJwtPayload(accessToken));
  }

  clear(): void {
    this._user.set(null);
  }
}
